export default function LoadingScreen({ label = "Syncing" }) {
  return (
    <div
      className="min-h-screen relative overflow-hidden flex flex-col items-center justify-center gap-6"
      data-testid="loading-screen"
    >
      {/* Ambient backdrop matching the app shell */}
      <div className="sl-ambient-grid" aria-hidden="true" />
      <div className="sl-ambient-spotlight" aria-hidden="true" />

      <div className="relative w-[180px] h-[180px] flex items-center justify-center">
        {/* Rotating orbital ring */}
        <svg
          className="absolute inset-0"
          width="180"
          height="180"
          viewBox="0 0 180 180"
          style={{ animation: "sl-orbit 6s linear infinite", transformOrigin: "center" }}
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="ring-grad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#f58220" stopOpacity="0" />
              <stop offset="55%" stopColor="#f58220" stopOpacity="0.95" />
              <stop offset="100%" stopColor="#ffb347" stopOpacity="0" />
            </linearGradient>
          </defs>
          <circle
            cx="90"
            cy="90"
            r="80"
            fill="none"
            stroke="url(#ring-grad)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="260 240"
          />
        </svg>

        {/* Inner soft ring (static) */}
        <div
          className="absolute inset-6 rounded-full"
          style={{
            border: "1px solid rgba(245, 130, 32, 0.18)",
            boxShadow: "0 0 40px -10px rgba(245, 130, 32, 0.35) inset",
          }}
          aria-hidden="true"
        />

        {/* Breathing logo */}
        <img
          src="/shiftlog-logo.png?v=pl2"
          alt="PIT LINK"
          className="w-[140px] select-none pointer-events-none relative z-10 sl-logo-glow-strong"
          draggable="false"
          style={{ animation: "sl-breathe 2.6s ease-in-out infinite" }}
        />
      </div>

      <div className="flex flex-col items-center gap-2 relative z-10">
        <div className="font-display uppercase tracking-[0.4em] text-sm font-black text-white text-glow-white">
          {label}
        </div>
        <div className="flex gap-1.5" aria-hidden="true">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="inline-block w-1.5 h-1.5 rounded-full"
              style={{
                background: "var(--primary)",
                animation: "sl-breathe 1.2s ease-in-out infinite",
                animationDelay: `${i * 180}ms`,
                boxShadow: "0 0 8px var(--primary-glow)",
              }}
            />
          ))}
        </div>
        <div className="mt-1 text-[10px] uppercase tracking-[0.35em] text-white/40 data-num">
          Site · Crew · Live Feed
        </div>
      </div>
    </div>
  );
}
